import React from 'react';
import { Typography, Link } from '@fiverr-private/typography';
import { Alert, AlertTitle, AlertText } from '@fiverr-private/feedback';
import { Chat } from '@fiverr-private/support_chat_trigger';
import { CONTACT_SUPPORT_URL } from '../../constants/urls';
import { appTranslate } from '../../i18n';

interface ReachedMaxLicensesAlertProps {
    totalQuantity: number;
}

export const ReachedMaxLicensesAlert = ({ totalQuantity }: ReachedMaxLicensesAlertProps) => {
    const onSupportClick = (event) => {
        event.preventDefault();
        Chat.toggle({ metaData: 'Subscription365Button - Max reached' });
    };

    return (
        <Alert variant="error">
            <AlertTitle>
                <Typography as="span" fontSize="b_sm" fontWeight="semibold">
                    {appTranslate('subscription_drawer.fields.quantity.errors.max_users.title')}
                </Typography>
            </AlertTitle>
            <AlertText>
                <Typography fontSize="b_sm">
                    {appTranslate('subscription_drawer.fields.quantity.errors.max_users.message', {
                        params: {
                            max: totalQuantity,
                        },
                        templates: {
                            contactSupport: (text?: string) => (
                                <Link
                                    target="_blank"
                                    href={CONTACT_SUPPORT_URL}
                                    onClick={onSupportClick}
                                    rel="noopener noreferrer"
                                >
                                    {text}
                                </Link>
                            ),
                        },
                    })}
                </Typography>
            </AlertText>
        </Alert>
    );
};
